/**
 * Portal Theme Preset
 *
 * This is the main theme composition for the ISLAcare Portal application.
 * It extends PrimeNG's Aura preset with custom primitives, semantic tokens,
 * and component customisations.
 *
 * Architecture (per PrimeNG v19):
 * 1. Primitives: Base values (orange.500, gray.300) - no context
 * 2. Semantic: Design meanings (primary.color → {orange.500})
 * 3. Components: Component-specific (button.background → {primary.color})
 * 4. CSS: Only use when design tokens cannot achieve the desired result
 *
 * @see https://primeng.org/theming#architecture
 */
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { componentTokens } from '../components';
import { primitiveTokens } from '../primitives';
import { semanticTokens } from '../semantic';

export const PortalTheme = definePreset(Aura, {
  primitive: primitiveTokens,
  semantic: semanticTokens,
  components: componentTokens,
  css: `
    /*
     * PrimeNG v20 adds an invisible nbsp ::after spacer to icon-only buttons,
     * which forces their height up to a full line-box (~44px) — taller than
     * standard text buttons (~37px). Removing it lets icon-only buttons (e.g. the
     * nav-bar quick-submit/camera button) match standard button height, as in v19.
     * See CLP-665.
     */
    .p-button-icon-only::after {
      content: none;
    }

    .p-chip-remove-icon {
      font-size: 12px !important ;
    }

    .p-galleria-thumbnails-viewport, .p-galleria-thumbnails-content {
      height: 100% !important;
    }

    .iti--container {
      z-index: 99999 !important;
    }
  `,
});
